const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/roles/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { Spinner } from '@tempo-io/sui-spinner';
import i18n from '@/common/translations/i18n';
import { getSearchTeamRolesQueryOptions } from '@/features/settings/team-roles/queries/useTeamRolesQuery';
export const Route = createFileRoute('/(app)/org/$org/settings/roles/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context: {
      queryClient
    }
  }): Promise<LoaderData> => {
    await queryClient.ensureQueryData(getSearchTeamRolesQueryOptions());
    return {
      crumb: i18n.t($ => $.common.settings.roles.label)
    };
  },
  pendingComponent: () => <div className="flex items-center justify-center h-full">
      <Spinner size={32} />
    </div>,
  staticData: {
    topNav: {
      title: i18n.t($ => $.common.settings.roles.label)
    }
  }
});